import { useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full items-center gap-3 px-4 md:px-6">
        <a href="#top" className="flex cursor-pointer items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-lg" />
          </span>
          <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">黑料热点</h1>
        </a>

        <nav className="ml-auto hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#collections"
          className="ml-2 hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-block"
        >
          进入合集
        </a>

        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-label="打开导航菜单"
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-950 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer border-b border-background-100 py-3 text-sm text-foreground-700 last:border-0"
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}